<template>
  <router-view />
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "VoterViewController",

  computed: {
    isLoggedIn() {
      return this.$store.getters.getAuthStatus;
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),
  },

  async mounted() {
    if (!this.isLoggedIn) {
      if (this.$route.name !== "LogIn") this.$router.push({ name: "LogIn" });
      return;
    }

    const res = await this.makeFetch({
      method: "get",
      goTo: "/polls",
    }).catch(console.error);

    if (res)
      if (res.data.length > 0)
        if (this.$route.name !== "VotePage")
          this.$router.push({
            name: "VotePage",
            params: { id: res.data[0].id },
          });
        else {
          localStorage.clear();
          if (this.$route.name !== "LogIn")
            this.$router.push({ name: "LogIn" });
        }
  },
};
</script>
